import { lazy, useEffect, useState } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const CreateCampaignPage = lazy(() => import('../pages/create-campaign/page'));
const AdTemplatesPage = lazy(() => import('../pages/ad-templates/page'));
const LeadsCRMPage = lazy(() => import('../pages/leads-crm/page'));
const AnalyticsPage = lazy(() => import('../pages/analytics/page'));
const SettingsPage = lazy(() => import('../pages/settings/page'));
const FranchiseApplyPage = lazy(() => import('../pages/franchise-apply/page'));
const FranchiseLandingPage = lazy(() => import('../pages/franchise-landing/page'));
const FranchiseApplicationsPage = lazy(() => import('../pages/franchise-applications/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

function AuthGuard({ children }: { children: React.ReactNode }) {
  const [authenticated, setAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const check = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setAuthenticated(!!session);
    };
    check();
  }, []);

  if (authenticated === null) return null;
  if (!authenticated) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/dashboard" replace />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/franchise-apply',
    element: <FranchiseApplyPage />
  },
  {
    path: '/franchise-landing',
    element: <FranchiseLandingPage />
  },
  {
    path: '/dashboard',
    element: <AuthGuard><DashboardPage /></AuthGuard>
  },
  {
    path: '/create-campaign',
    element: <AuthGuard><CreateCampaignPage /></AuthGuard>
  },
  {
    path: '/ad-templates',
    element: <AuthGuard><AdTemplatesPage /></AuthGuard>
  },
  {
    path: '/leads-crm',
    element: <AuthGuard><LeadsCRMPage /></AuthGuard>
  },
  {
    path: '/analytics',
    element: <AuthGuard><AnalyticsPage /></AuthGuard>
  },
  {
    path: '/settings',
    element: <AuthGuard><SettingsPage /></AuthGuard>
  },
  {
    path: '/franchise-applications',
    element: <AuthGuard><FranchiseApplicationsPage /></AuthGuard>
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
